import {
    Supercategory,
    TransactionEntryCategoryFieldsFragment,
} from '../graphql/generated';

export const sampleTransactionEntryCategories: TransactionEntryCategoryFieldsFragment[] =
    [
        {
            id: '07e7d0b4-bdf0-4eda-909b-9efd56313e61',
            description: 'Other loan payments',
            iconName: 'Certificate02',
            name: 'Other Loan Payment',
            userId: null,
            categoryGroup: {
                id: '99a65bab-7976-4e37-ba4a-22969049fa3b',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Loan Payments',
                userId: null,
                iconName: 'CreditCardDownload',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '087ba921-22a6-4f08-a690-5d5965e8ad31',
            description: 'Home improvement retailers incl. hardware stores',
            iconName: 'HomeSmile',
            name: 'Home Improvement',
            userId: null,
            categoryGroup: {
                id: '0589b234-3f92-4460-baf9-e452bb09f367',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Shopping',
                userId: null,
                iconName: 'ShoppingCart01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '14fa2957-f171-4036-b7fc-bc45c70856b0',
            description: 'Pharmacy stores',
            iconName: 'Pharmacy',
            name: 'Pharmacy',
            userId: null,
            categoryGroup: {
                id: '5fc27df3-dedc-41d9-9355-78af84add3f7',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Health and Wellness',
                userId: null,
                iconName: 'HeartCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '171a3a5d-2d22-40c4-af24-261fdfa79d57',
            description:
                'Government agencies incl. driving licences, and passport renewal',
            iconName: 'Building08',
            name: 'Government Agency',
            userId: null,
            categoryGroup: {
                id: 'ec5a53e1-d106-4f48-8c2d-5b1323306304',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Government',
                userId: null,
                iconName: 'Scales02',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '1acb10ec-1883-4e5a-942d-58024d887317',
            description: 'Car loan or lease payments',
            iconName: 'Car01',
            name: 'Car Payment',
            userId: null,
            categoryGroup: {
                id: '99a65bab-7976-4e37-ba4a-22969049fa3b',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Loan Payments',
                userId: null,
                iconName: 'CreditCardDownload',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '1c12e185-a429-4c1d-a06f-6714bb9e5a10',
            description:
                'Services for oil changes, car washes, repairs and towing.',
            iconName: 'Tool02',
            name: 'Vehicle Services',
            userId: null,
            categoryGroup: {
                id: '82d8ad8c-1b9a-4174-8284-15ee67d08184',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Services',
                userId: null,
                iconName: 'Doctor',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '20ad8a59-c5a6-4ca0-b230-2a8223f3ef07',
            description: 'Rent payments',
            iconName: 'Building01',
            name: 'Rent',
            userId: null,
            categoryGroup: {
                id: '7feff6a7-752d-464b-8ccf-5a68c4fc46fc',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Housing',
                userId: null,
                iconName: 'Home03',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '21e96574-129a-4914-aefd-d2daef33fd98',
            description: 'Income from retirement payments',
            iconName: 'Safe',
            name: 'Retirement',
            userId: null,
            categoryGroup: {
                id: '228858fc-046d-4d7b-a620-9f08d0522864',
                supercategory: 'INCOME' as Supercategory,
                name: 'Income',
                userId: null,
                iconName: 'CurrencyDollarCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '26ea316d-eaa5-495d-9ab8-c0ad6b4069dd',
            description: 'Income from unemployment benefits',
            iconName: 'CoinsHand',
            name: 'Unemployment',
            userId: null,
            categoryGroup: {
                id: '228858fc-046d-4d7b-a620-9f08d0522864',
                supercategory: 'INCOME' as Supercategory,
                name: 'Income',
                userId: null,
                iconName: 'CurrencyDollarCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '29a9ca7a-91cf-4cc7-8f80-5788f4562979',
            description: 'Pet supply stores',
            iconName: 'Dog',
            name: 'Pet Supplies',
            userId: null,
            categoryGroup: {
                id: 'da865535-1058-4bba-a06d-ca372727532c',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Pet',
                userId: null,
                iconName: 'Dog',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '305064e5-fcb0-442f-a0d1-8c3a5b1f518d',
            description:
                'Transportation incl. bike or scooter rental, parking fees, and tolls',
            iconName: 'MarkerPin01',
            name: 'General Transportation',
            userId: null,
            categoryGroup: {
                id: '5bd368eb-fb49-403f-9e1c-c4c85231f83f',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Transportation',
                userId: null,
                iconName: 'Car01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '39492931-2c2f-4b7a-b30f-97c238bb225a',
            description: 'Tax payments incl. income and property',
            iconName: 'File06',
            name: 'Tax',
            userId: null,
            categoryGroup: {
                id: 'ec5a53e1-d106-4f48-8c2d-5b1323306304',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Government',
                userId: null,
                iconName: 'Scales02',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
            description:
                'Music streaming, or tickets for concerts and festivals',
            iconName: 'MusicNote01',
            name: 'Music and Events',
            userId: null,
            categoryGroup: {
                id: '586eea33-ef76-4595-9227-52c916c13b28',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Entertainment',
                userId: null,
                iconName: 'VideoRecorder',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '44395cad-1f92-4a23-93eb-89862e433b55',
            description: 'Taxi and ride share services',
            iconName: 'CarPayment',
            name: 'Taxi and Rideshare',
            userId: null,
            categoryGroup: {
                id: '5bd368eb-fb49-403f-9e1c-c4c85231f83f',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Transportation',
                userId: null,
                iconName: 'Car01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '47dcb5ea-bf36-4340-99e5-2e59adf42ff2',
            description: 'Gyms, fitness centers, and workout classes',
            iconName: 'Gym',
            name: 'Gym',
            userId: null,
            categoryGroup: {
                id: '5fc27df3-dedc-41d9-9355-78af84add3f7',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Health and Wellness',
                userId: null,
                iconName: 'HeartCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '4a4c2ead-3e00-4e1f-9ad6-0c4196e31d8f',
            description:
                'Manicures, haircuts, waxing, spa, and bath and beauty',
            iconName: 'HairBeauty',
            name: 'Beauty',
            userId: null,
            categoryGroup: {
                id: '5fc27df3-dedc-41d9-9355-78af84add3f7',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Health and Wellness',
                userId: null,
                iconName: 'HeartCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '4dcd0b87-b00b-4934-8772-842cc3210ffa',
            description: 'Insurance for home, vehicle, and medical',
            iconName: 'ShieldTick',
            name: 'Insurance',
            userId: null,
            categoryGroup: {
                id: '82d8ad8c-1b9a-4174-8284-15ee67d08184',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Services',
                userId: null,
                iconName: 'Doctor',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '4f0ff69f-270f-43cf-b38f-25a8f6e77cbb',
            description:
                'Services incl. cleaning, laundry, landscaping, or handyman',
            iconName: 'Home03',
            name: 'Home',
            userId: null,
            categoryGroup: {
                id: '82d8ad8c-1b9a-4174-8284-15ee67d08184',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Services',
                userId: null,
                iconName: 'Doctor',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '511d613b-df12-4918-b57d-addd882b1721',
            description: 'Clothing retailers incl. shoes and jewelry',
            iconName: 'Shirt',
            name: 'Clothing',
            userId: null,
            categoryGroup: {
                id: '0589b234-3f92-4460-baf9-e452bb09f367',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Shopping',
                userId: null,
                iconName: 'ShoppingCart01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '52ecc268-7869-49d6-a266-fc38eb71c7ac',
            description:
                'Income from salaries, hourly wages, consulting fees, or tips',
            iconName: 'BankNote02',
            name: 'Wages',
            userId: null,
            categoryGroup: {
                id: '228858fc-046d-4d7b-a620-9f08d0522864',
                supercategory: 'INCOME' as Supercategory,
                name: 'Income',
                userId: null,
                iconName: 'CurrencyDollarCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '543158d2-9e62-4394-97bb-922f1ab64e34',
            description: 'Money transferred into the account',
            iconName: 'ArrowCircleBrokenRight',
            name: 'Transfer In',
            userId: null,
            categoryGroup: {
                id: '350d8c14-d239-4eec-8d3a-172e9cdd9269',
                supercategory: 'TRANSFERS' as Supercategory,
                name: 'Transfers',
                userId: null,
                iconName: 'CoinsSwap01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '5488e3f4-890b-4f0b-a689-e27ab88b5229',
            description:
                'Personal loans (incl. cash advances, or buy now pay later) payments',
            iconName: 'Certificate01',
            name: 'Personal Loan Payment',
            userId: null,
            categoryGroup: {
                id: '99a65bab-7976-4e37-ba4a-22969049fa3b',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Loan Payments',
                userId: null,
                iconName: 'CreditCardDownload',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '61d04897-6e6b-4350-a69a-2853e81f1a57',
            description: 'Bars, nightlife, or purchases from liquor stores',
            iconName: 'WineGlass',
            name: 'Bars, Nightlife and Liquor',
            userId: null,
            categoryGroup: {
                id: '59129b18-1583-48d2-86d4-af5b309be510',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Food and Drink',
                userId: null,
                iconName: 'FoodDrink',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '62465088-302a-49d2-92e2-da1270d58bad',
            description: 'Income from tax refunds',
            iconName: 'Scales01',
            name: 'Tax Refund',
            userId: null,
            categoryGroup: {
                id: '228858fc-046d-4d7b-a620-9f08d0522864',
                supercategory: 'INCOME' as Supercategory,
                name: 'Income',
                userId: null,
                iconName: 'CurrencyDollarCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '6331d78b-aad8-4942-a733-c7a302f84c95',
            description:
                'Health and wellness services incl. therapy or massages',
            iconName: 'TwoPeople',
            name: 'Other Services',
            userId: null,
            categoryGroup: {
                id: '5fc27df3-dedc-41d9-9355-78af84add3f7',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Health and Wellness',
                userId: null,
                iconName: 'HeartCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '6523e0db-2f76-4549-b712-27edafa27643',
            description:
                'Pet services incl. veterinary services, boarding, or grooming',
            iconName: 'VeterinaryServices',
            name: 'Pet Services',
            userId: null,
            categoryGroup: {
                id: 'da865535-1058-4bba-a06d-ca372727532c',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Pet',
                userId: null,
                iconName: 'Dog',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '6edc921a-b9ce-4b44-a99d-a28a3b5c78c4',
            description: 'Uncategorized transactions',
            iconName: 'CurrencyDollarCircle',
            name: 'Miscellaneous',
            userId: null,
            categoryGroup: {
                id: '8de83c3d-370d-40ff-94cf-5e1b3ab3bdca',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Miscellaneous',
                userId: null,
                iconName: 'CurrencyDollarCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '70ea94d6-4925-4c26-8a8c-8d7f59b2d74a',
            description: 'Sporting events, or tickets for cultural venues',
            iconName: 'BaseballHat',
            name: 'Sports and Culture',
            userId: null,
            categoryGroup: {
                id: '586eea33-ef76-4595-9227-52c916c13b28',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Entertainment',
                userId: null,
                iconName: 'VideoRecorder',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '75303288-7233-4414-b8bd-c2b1e481914f',
            description: 'Gas and gas stations',
            iconName: 'Gas',
            name: 'Gas, Parking & Tolls',
            userId: null,
            categoryGroup: {
                id: '5bd368eb-fb49-403f-9e1c-c4c85231f83f',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Transportation',
                userId: null,
                iconName: 'Car01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '80425c56-dd6d-4762-b140-46c1a8cf713e',
            description:
                'Medical services providers incl. Primary, dental, and eye',
            iconName: 'MedicalCross',
            name: 'Medical Services',
            userId: null,
            categoryGroup: {
                id: '5fc27df3-dedc-41d9-9355-78af84add3f7',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Health and Wellness',
                userId: null,
                iconName: 'HeartCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '832c2958-5b3f-4e84-8bf0-8e7ecc6f8607',
            description: 'Gambling, casinos, and sports betting',
            iconName: 'Horseshoe',
            name: 'Gambling',
            userId: null,
            categoryGroup: {
                id: '586eea33-ef76-4595-9227-52c916c13b28',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Entertainment',
                userId: null,
                iconName: 'VideoRecorder',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '84b368e5-5595-4af1-b125-840badc276d2',
            description: 'Trades of securities within an investment account',
            iconName: 'ArrowsTriangle',
            name: 'Trades',
            userId: null,
            categoryGroup: {
                id: '350d8c14-d239-4eec-8d3a-172e9cdd9269',
                supercategory: 'TRANSFERS' as Supercategory,
                name: 'Transfers',
                userId: null,
                iconName: 'CoinsSwap01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '8813b8c2-cfa6-4c39-afc5-21d0e9f785ec',
            description:
                'Movie tickets, home video streaming services, or video games',
            iconName: 'TV02',
            name: 'TV, Movies, and Games',
            userId: null,
            categoryGroup: {
                id: '586eea33-ef76-4595-9227-52c916c13b28',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Entertainment',
                userId: null,
                iconName: 'VideoRecorder',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '8fdb2f06-a1f0-4f77-90c1-9be3287913a2',
            description: 'Deposits into saving and investment accounts',
            iconName: 'ArrowCircleUp',
            name: 'Saving and Investing Deposit',
            userId: null,
            categoryGroup: {
                id: '626dc21f-7632-419d-a98b-99a7781e5585',
                supercategory: 'SAVING_INVESTING' as Supercategory,
                name: 'Saving and Investing',
                userId: null,
                iconName: 'BarChart12',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '9336dab5-69ef-4bc8-a1d8-9d902a3fb426',
            description: 'Services incl. consulting or legal',
            iconName: 'Settings02',
            name: 'General Services',
            userId: null,
            categoryGroup: {
                id: '82d8ad8c-1b9a-4174-8284-15ee67d08184',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Services',
                userId: null,
                iconName: 'Doctor',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
            description: 'Dining out at restaurants, gastropubs, and diners',
            iconName: 'Restaurant',
            name: 'Restaurants',
            userId: null,
            categoryGroup: {
                id: '59129b18-1583-48d2-86d4-af5b309be510',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Food and Drink',
                userId: null,
                iconName: 'FoodDrink',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '9a9e0d00-cb98-42c2-91bf-e7a837ede421',
            description: 'Mortgage payments',
            iconName: 'Home03',
            name: 'Mortgage Payment',
            userId: null,
            categoryGroup: {
                id: '99a65bab-7976-4e37-ba4a-22969049fa3b',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Loan Payments',
                userId: null,
                iconName: 'CreditCardDownload',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: '9d9c2725-41fe-4623-9b6c-7f9e29b4606e',
            description: 'Books, magazines, and news',
            iconName: 'BookOpen01',
            name: 'Books and Publications',
            userId: null,
            categoryGroup: {
                id: '0589b234-3f92-4460-baf9-e452bb09f367',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Shopping',
                userId: null,
                iconName: 'ShoppingCart01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'a36c0d9c-18cb-450c-8ba2-6d1163cb7fb2',
            description: 'Money transferred out of the account',
            iconName: 'ArrowCircleBrokenLeft',
            name: 'Transfer Out',
            userId: null,
            categoryGroup: {
                id: '350d8c14-d239-4eec-8d3a-172e9cdd9269',
                supercategory: 'TRANSFERS' as Supercategory,
                name: 'Transfers',
                userId: null,
                iconName: 'CoinsSwap01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'a5d7240b-874d-4202-be1d-c908b9edc117',
            description:
                'Bank fees from ATMs, foreign transactions, insufficient funds, interest expenses, and overdraft fees',
            iconName: 'Bank',
            name: 'Bank Fees',
            userId: null,
            categoryGroup: {
                id: 'c4b75645-e423-40b4-9e3d-977d5d15b39d',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Bank Fees',
                userId: null,
                iconName: 'Bank',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'a68f44ca-cd4c-4d1c-8b3c-e80f04f23410',
            description: 'Dividends or interest earned',
            iconName: 'Coins01',
            name: 'Investment Return',
            userId: null,
            categoryGroup: {
                id: '228858fc-046d-4d7b-a620-9f08d0522864',
                supercategory: 'INCOME' as Supercategory,
                name: 'Income',
                userId: null,
                iconName: 'CurrencyDollarCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'a78521de-510c-4b67-9271-c0a294a2a6f4',
            description: 'Subscription services',
            iconName: 'Repeat01',
            name: 'Subscriptions',
            userId: null,
            categoryGroup: {
                id: '8da34343-7ea7-4f66-930a-c34f3c56970b',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Subscriptions',
                userId: null,
                iconName: 'Repeat01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'af4da3fc-703b-4d97-91d4-7111f9aef84c',
            description: 'Services for accounting and financial planning',
            iconName: 'LineChartUp02',
            name: 'Accounting and Planning',
            userId: null,
            categoryGroup: {
                id: '82d8ad8c-1b9a-4174-8284-15ee67d08184',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Services',
                userId: null,
                iconName: 'Doctor',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'bd805352-0584-4f0b-b07c-26bcadac617e',
            description: 'Grocery stores and delivery services',
            iconName: 'ShoppingCart01',
            name: 'Groceries',
            userId: null,
            categoryGroup: {
                id: '59129b18-1583-48d2-86d4-af5b309be510',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Food and Drink',
                userId: null,
                iconName: 'FoodDrink',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'c19f7dab-4bc9-42d5-8871-cbe9d513474a',
            description: 'Charitable, political, and religious donations',
            iconName: 'HeartHand',
            name: 'Donations',
            userId: null,
            categoryGroup: {
                id: '8c7ba150-8235-4c60-9ce1-2972a7a4797f',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Donations',
                userId: null,
                iconName: 'HeartHand',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
            description:
                'Online or in-person businesses that sell consumer goods, and electronics',
            iconName: 'ShoppingBag01',
            name: 'Stores',
            userId: null,
            categoryGroup: {
                id: '0589b234-3f92-4460-baf9-e452bb09f367',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Shopping',
                userId: null,
                iconName: 'ShoppingCart01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'c7252f80-4bc7-4130-a709-9041692d5071',
            description: 'Mail, packaging, and shipping services',
            iconName: 'Mail02',
            name: 'Postage and Shipping',
            userId: null,
            categoryGroup: {
                id: '82d8ad8c-1b9a-4174-8284-15ee67d08184',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Services',
                userId: null,
                iconName: 'Doctor',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'ca9f953c-a612-493f-8dfe-6a3e94b48117',
            description: 'Withdrawals from saving and investment accounts',
            iconName: 'ArrowCircleDown',
            name: 'Saving and Investing Withdrawal',
            userId: null,
            categoryGroup: {
                id: '626dc21f-7632-419d-a98b-99a7781e5585',
                supercategory: 'SAVING_INVESTING' as Supercategory,
                name: 'Saving and Investing',
                userId: null,
                iconName: 'BarChart12',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'cf4709af-fcea-4099-9eab-230d08323c0b',
            description:
                'Utilities incl. gas, electricity, water, garbage, internet and cable, and cell phone',
            iconName: 'Zap',
            name: 'Utilities',
            userId: null,
            categoryGroup: {
                id: '7feff6a7-752d-464b-8ccf-5a68c4fc46fc',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Housing',
                userId: null,
                iconName: 'Home03',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'd6655bf2-973f-4cde-a78b-59cdd30c2f74',
            description:
                'Travel incl. airline tickets, hotels, airbnbs, and rental cars',
            iconName: 'Globe05',
            name: 'Travel',
            userId: null,
            categoryGroup: {
                id: '33167340-2134-4122-8174-d41150c0575f',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Travel',
                userId: null,
                iconName: 'Globe05',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'da9d599f-0658-4d4b-81da-083d40d2d9cc',
            description: 'Student loan payments',
            iconName: 'GraduationHat01',
            name: 'Student Loan Payment',
            userId: null,
            categoryGroup: {
                id: '99a65bab-7976-4e37-ba4a-22969049fa3b',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Loan Payments',
                userId: null,
                iconName: 'CreditCardDownload',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'ea0708ef-8ea4-412d-a831-eeacdfd8c744',
            description: 'Gifts purchased at retailers',
            iconName: 'Gift01',
            name: 'Gifts',
            userId: null,
            categoryGroup: {
                id: '0589b234-3f92-4460-baf9-e452bb09f367',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Shopping',
                userId: null,
                iconName: 'ShoppingCart01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
            description: 'Coffee shops and cafes',
            iconName: 'Coffee',
            name: 'Coffee',
            userId: null,
            categoryGroup: {
                id: '59129b18-1583-48d2-86d4-af5b309be510',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Food and Drink',
                userId: null,
                iconName: 'FoodDrink',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'ef122a51-7312-46ca-b83e-cde72f64aada',
            description:
                'Tuition for elementary, high school, professional schools, and college',
            iconName: 'Telescope',
            name: 'Education',
            userId: null,
            categoryGroup: {
                id: '82d8ad8c-1b9a-4174-8284-15ee67d08184',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Services',
                userId: null,
                iconName: 'Doctor',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'f13a4d58-4ca7-4ceb-8646-4cfe901cec82',
            description:
                'Expenses incurred for your job, small business, or side hustle',
            iconName: 'BriefCase02',
            name: 'Work Expenses',
            userId: null,
            categoryGroup: {
                id: '08bcb227-63e1-4fb3-8ebd-47e82673021d',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Work Expenses',
                userId: null,
                iconName: 'BriefCase02',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'f8b9be2c-94f6-4f2b-aec3-a8b020f83565',
            description: 'Services for babysitters and daycare',
            iconName: 'Childcare',
            name: 'Childcare',
            userId: null,
            categoryGroup: {
                id: '82d8ad8c-1b9a-4174-8284-15ee67d08184',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Services',
                userId: null,
                iconName: 'Doctor',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'f9242742-aeca-4c3f-a7b4-89dd0f2bfe21',
            description:
                'Public transportation incl. rail and train, buses, and subway',
            iconName: 'Bus',
            name: 'Public Transit',
            userId: null,
            categoryGroup: {
                id: '5bd368eb-fb49-403f-9e1c-c4c85231f83f',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Transportation',
                userId: null,
                iconName: 'Car01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'fb28d659-7888-43a8-9117-45db58d22c71',
            description: 'Furniture and home good retailers',
            iconName: 'Chair',
            name: 'Furniture',
            userId: null,
            categoryGroup: {
                id: '0589b234-3f92-4460-baf9-e452bb09f367',
                supercategory: 'SPENDING' as Supercategory,
                name: 'Shopping',
                userId: null,
                iconName: 'ShoppingCart01',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
        {
            id: 'feca1866-7a05-4231-a270-b74760bff8d3',
            description:
                'Other income including rental income, alimony/child support, or social security',
            iconName: 'BankNote01',
            name: 'Other Income',
            userId: null,
            categoryGroup: {
                id: '228858fc-046d-4d7b-a620-9f08d0522864',
                supercategory: 'INCOME' as Supercategory,
                name: 'Income',
                userId: null,
                iconName: 'CurrencyDollarCircle',
                __typename: 'TransactionEntryCategoryGroup',
            },
            __typename: 'TransactionEntryCategory',
        },
    ];
